import type { AddOnsData, AddOnsHandlers } from '@ctct/application-layer';
import { SmsBundleTierSelect } from '@ctct/payflow-ui';
import type { AddOnsHooks } from '@ctct/state-client-layer';

interface Props {
  data: AddOnsData;
  handlers: AddOnsHandlers;
  hooks: AddOnsHooks;
  inConfiguratorRow?: boolean;
  isDisabled?: boolean;
}

export const SmsBundleTierSelectWidgetContent = ({
  data,
  handlers,
  hooks,
  inConfiguratorRow = false,
  isDisabled = false,
}: Props) => {
  const selectedTier = hooks.useSelectedSmsBundleTier();
  const options = data.getSmsBundleTierOptions();
  const label = data.getSmsBundleTierLabel();
  const valueFocusedMWebInline = data.getIsValueFocusedMWebTierSelectPresentation();
  const ariaLabel = data.getSmsBundleTierSelectAriaLabel();
  const placeholder = data.getSmsBundleTierSelectPlaceholder();

  if (options.length === 0) {
    return null;
  }

  // The dropdown contains real tiers only — no "None" sentinel. When nothing is selected
  // (initial state, or after Remove from the order summary) we pass `undefined` so Radix
  // renders the placeholder instead.
  const isSelected = selectedTier !== null && options.some((option) => option.value === selectedTier);
  const selectedValue = isSelected ? selectedTier : undefined;

  return (
    <SmsBundleTierSelect
      inConfiguratorRow={inConfiguratorRow}
      valueFocusedMWebInline={valueFocusedMWebInline}
      ariaLabel={ariaLabel}
      label={label}
      options={options}
      value={selectedValue}
      placeholder={placeholder}
      onChange={handlers.onSmsBundleTierChange}
      disabled={isDisabled}
    />
  );
};
